import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { BaseCell, BaseHeader } from './Column';
import { Css } from '../../../../../../ui';

interface IProps {
	codeShareFlightNumber: string;
}

const styles = css`
	min-width: 130px;
	flex-grow: 0;
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	font-weight: 300;
	font-size: ${Css.pxToRem(14)};
`;

export function Header() {
	return <StyledHeader>Flight Number</StyledHeader>;
}

export function Cell({ codeShareFlightNumber }: IProps) {
	return <StyledCell>{codeShareFlightNumber}</StyledCell>;
}
